import { AnyAction, Dispatch } from 'redux';
import { getAllCategory, getAllBrands } from '../../../services/supplier.service';
import { getSeasons, getSupplier } from '../../../services/supplierSuggestion.service';
import {
  getAllCustomAttribute,
  getMultiCustomAttribute,
  getAllPCTypes,
  getAllLengths,
  getAllProductStatus,
} from '../../../services/SystemMaster.services';
import {
  postPlaceholderData,
  getPlaceholderData as getPlaceholderDataService,
  deletePlaceholder,
  updateQty as updateQtyService,
  getPlaceholderProduct,
  postPlaceholderProductData,
  saveDraftData,
  getSearchedProductListService,
  publishPlacheholderManagement,
  replacePlaceholderSevice,
  addPlaceholderCard as addPlaceholderCardService,
  getIndividualDetails as getIndividualDetailsService,
  getPlaceholderCardData as getPlaceholderCardDataService,
  deletePlaceholderCardData as deletePlaceholderCardDataService,
  archivePlaceholderCardData as archivePlaceholderCardDataService,
} from '../../../services/placeholder.service';
import { updateDevOrder, getDevOrderById, getProductTags, getDevOrderEditRules, changeGrading } from '../../../services/developmentOrder.service';
import { getGrading } from '../../../services/pom.services';
import { getColorLibrary } from '../../../services/color-library.service';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { ERROR_MESSAGE, getApiErrorKey, backendErrorMsg } from '../../../Components/helper';
import { PlaceholderManagementType } from './placeholder.types';
import { TranslateFn } from '../types';
import { PLACEHOLDER_I18N_NAMESPACE } from '../placeholder.constants';

interface ApiResponseBody {
  code: number;
  message: string;
  data: any;
}

interface FetchCategoriesParams {
  categoryType?: number;
  [key: string]: unknown;
}

export const fetchCategoriesAction = (params: FetchCategoriesParams) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getAllCategory(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      switch (params.categoryType) {
        case 1:
          await dispatch({
            type: PlaceholderManagementType.CATEGORY1,
            payload: res.data,
          });
          return res.data;

        case 2:
          await dispatch({
            type: PlaceholderManagementType.CATEGORY2,
            payload: res.data,
          });
          return res.data;

        default:
          return res.data;
      }
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params: Record<string, unknown>) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getAllBrands(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.BRANDS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllSeasonsAction = (id: string) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getSeasons(id)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SEASONS,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllDynamicField = () => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getAllCustomAttribute()) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.DYNAMIC_COLUMN,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllMultiDynamicField = () => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getMultiCustomAttribute({ isActive: true })) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.MULTI_DYNAMIC_COLUMN,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllProductType = (params: Record<string, unknown>) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getAllPCTypes(params)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.PRODUCT_TYPE,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const savePlaceholderData = (params: Record<string, unknown>, transactionMsg: TranslateFn) => async () => {
  try {
    const res = (await postPlaceholderData(params)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PLACEHOLDER.${res.message}`);

      if (res.data?.errorList && res.data.errorList.length > 0) {
        toasterMsg(transactionMsg('BACKEND_SERVER.PLACEHOLDER_MANAGEMENT.PLACE_HOLDER_MANAGEMENT_SERVICE.COLUMN_SHOULD_UNIQUE'), 'danger');
      } else {
        toasterMsg(msg, 'success');
      }
      return res;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const getPlaceholderData = (params: Record<string, unknown>) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getPlaceholderDataService(params)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.PLACEHOLDER_DATA,
        payload: res.data,
      });
      return res.data;
    }
    return res;
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const filterSortData = (obj: Record<string, unknown>) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    await dispatch({
      type: PlaceholderManagementType.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const deletePlaceholderData = (params: Record<string, unknown>, transactionMsg: TranslateFn) => async () => {
  try {
    const res = (await deletePlaceholder(params)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const updateQty = (params: Record<string, unknown>, transactionMsg: TranslateFn) => async () => {
  try {
    const res = (await updateQtyService(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      const msg = transactionMsg(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    if ([400].includes(res.code) && res?.data) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    if ([500].includes(res.code) && res?.data) {
      const msg = transactionMsg(`${res?.data?.errMsg}`);
      toasterMsg(msg, 'danger');
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllSupplierTypeAction = (params: Record<string, unknown>) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getAllPCTypes(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SUPPLIERTYPE,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchPlaceholderProduct = (params: Record<string, unknown>) => async () => {
  try {
    const res = (await getPlaceholderProduct(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const savePlaceholderProductAction = (params: Record<string, unknown>) => async () => {
  try {
    const res = (await postPlaceholderProductData(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      toasterMsg('Products updated successfully.', 'success');
      return res;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllLength = (data: Record<string, unknown>) => async () => {
  try {
    const res = (await getAllLengths(data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllColour = (data: Record<string, unknown>) => async () => {
  try {
    const res = (await getColorLibrary(data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllProductStatus = (data: Record<string, unknown>) => async () => {
  try {
    const res = (await getAllProductStatus(data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchAllGrading = (data: Record<string, unknown>) => async () => {
  try {
    const res = (await getGrading(data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchCustomAttribute = (data: Record<string, unknown>) => async () => {
  try {
    const res = (await getAllCustomAttribute(data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const fetchSupplier = (data: Record<string, unknown>) => async () => {
  try {
    const res = (await getSupplier(data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const getProductDetailById = (id: string) => async () => {
  try {
    const res = (await getDevOrderById(id)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const updateProduct = (id: string, data: Record<string, unknown>, transactionMsg: TranslateFn) => async () => {
  try {
    const res = (await updateDevOrder(id, data)) as unknown as ApiResponseBody;

    if (res.code === 200 && res.data) {
      toasterMsg('Product updated successfully.', 'success');
      return res.code;
    }
    if (res.data?.errMsg) {
      toasterMsg(transactionMsg(res.data.errMsg as string), 'danger');
    }
  } catch (err) {
    const errorKey = getApiErrorKey(err);
    toasterMsg(errorKey ? transactionMsg(errorKey) : ERROR_MESSAGE, 'danger');
  }
};

export const getOtherProductTags = () => async () => {
  try {
    const res = (await getProductTags()) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const getProductEditRules = (id: string) => async () => {
  try {
    const res = (await getDevOrderEditRules(id)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const postProductChangeGrading = (id: string) => async () => {
  try {
    const res = (await changeGrading(id)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const saveDraftholderProductAction = (params: Record<string, unknown>) => async () => {
  try {
    const res = (await saveDraftData(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      toasterMsg('Saved successfully.', 'success');
      return res;
    }
    if (res.code === 500) {
      toasterMsg('Please fill required fields', 'danger');
    }
  } catch (err) {
    console.log('errrrrrrrr', err);
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const getSearchedProductList = (value: string) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getSearchedProductListService(value)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SEARCHED_PRODUCTS,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const publishPlaceholderAction = (params: Record<string, unknown>) => async () => {
  try {
    const res = (await publishPlacheholderManagement(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      toasterMsg('Published successfully.', 'success');
      return res;
    }
    if (res.code === 400 && res.data) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const replacePlaceholderAction = (params: Record<string, unknown>, t: TranslateFn) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await replacePlaceholderSevice(params)) as unknown as ApiResponseBody;
    if (res.code === 200) {
      await dispatch({
        type: PlaceholderManagementType.SEARCHED_PRODUCTS,
        payload: [],
      });
      toasterMsg(t(res?.message), 'success');
    }
    return res;
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const clearReducer = () => async (dispatch: Dispatch<AnyAction>) => {
  try {
    await dispatch({
      type: PlaceholderManagementType.CLEAR_REDUCER,
    });
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

/**
 * Translate a backend error key through this module's own i18n namespace,
 * falling back to the generic message when the key has no translation.
 */
const translatePlaceholderError = (t: TranslateFn, errorKey: string): string =>
  backendErrorMsg((key: string) => t(`${PLACEHOLDER_I18N_NAMESPACE}:${key}`), errorKey);

/**
 * Saves (creates or updates) a placeholder card and returns its id.
 *
 * Business failures (duplicate / archived card name) arrive as an HTTP 200
 * envelope with a non-200 `code` and the backend key in `data.errMsg`, so they
 * are surfaced as a toast here and `null` is returned — callers must never
 * treat the failure envelope itself as a saved id.
 */
export const addPlaceholderCard = (params: Record<string, unknown>, t: TranslateFn) => async (): Promise<string | null> => {
  try {
    const res = (await addPlaceholderCardService(params)) as unknown as ApiResponseBody;
    if (res.code === 200) {
      const msg = t(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return res.data as string;
    }
    const errorKey = (res?.data as { errMsg?: string } | undefined)?.errMsg;
    toasterMsg(translatePlaceholderError(t, errorKey ?? ''), 'danger');
    return null;
  } catch (err) {
    toasterMsg(translatePlaceholderError(t, getApiErrorKey(err)), 'danger');
    return null;
  }
};

export const getIndividualDetails = (id: string) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getIndividualDetailsService(id)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.SET_INDIVIDUAL_DETAILS,
        payload: res.data,
      });
    }
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const getPlaceholderCardData = (params: Record<string, unknown>) => async (dispatch: Dispatch<AnyAction>) => {
  try {
    const res = (await getPlaceholderCardDataService(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      await dispatch({
        type: PlaceholderManagementType.GET_PLACEHOLDER_CARD_DATA,
        payload: { ...res.data, pageIndex: params?.pageIndex },
      });
      return true;
    }
    return true;
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
    return false;
  }
};

export const deletePlaceholderCardData = (params: Record<string, unknown>, t: TranslateFn) => async () => {
  try {
    const res = (await deletePlaceholderCardDataService(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      const msg = t(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    return false;
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
    return false;
  }
};

export const clearIndividualReducer = () => async (dispatch: Dispatch<AnyAction>) => {
  try {
    await dispatch({
      type: PlaceholderManagementType.CLEAR_INDIVIDUAL_REDUCER,
    });
    return true;
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
  }
};

export const archivePlaceholderCardData = (params: Record<string, unknown>, t: TranslateFn) => async () => {
  try {
    const res = (await archivePlaceholderCardDataService(params)) as unknown as ApiResponseBody;
    if (res.code === 200 && res.data) {
      const msg = t(`PLACEHOLDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    return false;
  } catch (err) {
    toasterMsg((err as Error).toString(), 'danger');
    return false;
  }
};
